import React from "react";

/**
 * Exported so non-chip surfaces that need to match a chip — an inline banner saying the
 * same thing, say — use the same pair rather than re-typing the hex and drifting.
 */
export const chipColors = {
  success: { text: "#2e7d32", bg: "#c8facc" },
  error: { text: "#a71d2a", bg: "#f5b7b1" },
  warning: { text: "#b06b00", bg: "#ffe5b4" },
  // Neutral-informational, for a value that is neither good nor bad but worth
  // reading — a workflow position, say. A light blue, kept clearly distinct from the
  // green/amber/red above so it never reads as an outcome.
  info: { text: "#1565c0", bg: "#e3f2fd" },
  default: { text: "#555555", bg: "#e0e0e0" },
};

/**
 * Canonical status → tone mapping for the Operations / Store screens.
 *
 * This was duplicated verbatim as a local `StatusBadge` in WorkOrderDetailsPage and
 * PurchaseOrderDetailsPage, while the two list grids coloured the same values with
 * hand-written `cellStyle` hex instead — three renderings of one idea. Exported here so
 * a status reads the same everywhere it appears.
 *
 * Precedence is error > warning > success > info, which reproduces what the detail
 * pages already did: their `if`s had no `else`, so a later match overwrote an earlier
 * one. That matters for composite statuses like "Approved - Pending Receipt", where the
 * outstanding half is the part worth flagging.
 *
 * Substring matching, not equality, because Purchase Order statuses are composite.
 * `info` is for workflow positions that are neither good nor bad — see `chipColors`.
 */
export const statusChipType = (status) => {
  const s = (status || "").toLowerCase();
  if (!s) {
    return "default";
  }
  if (s.includes("reject") || s.includes("cancel") || s.includes("delete")) {
    return "error";
  }
  if (s.includes("pending") || s.includes("partial")) {
    return "warning";
  }
  if (
    s.includes("approved") ||
    s.includes("completed") ||
    s.includes("paid") ||
    s.includes("issued")
  ) {
    return "success";
  }
  if (s.includes("progress") || s.includes("received")) {
    return "info";
  }
  return "default";
};

const StatusChip = ({ status, type, onClick, smWidth = false }) => {
  const { text, bg } = chipColors[type] || chipColors.default;

  return (
    <div>
      {/* <div style={{ textAlign: "center" }}> */}
      <span
        onClick={onClick}
        style={{
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          // minWidth: smWidth ? "40px" : "90px",
          height: "25px",
          padding: "4px 10px",
          borderRadius: "5px",
          fontSize: "10px",
          fontWeight: "bold",
          color: text,
          backgroundColor: bg,
          cursor: onClick ? "pointer" : "default",
          userSelect: "none",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        {status || "N/A"}
      </span>
    </div>
  );
};

export default StatusChip;
